class VwHbsIslemtanimDTO {
    id?: number = 0;
    kodu?: string = "";
    adi?: string = "";
    grupId?: number = null;
    aktif?: string = "E";
    aktifBool?: boolean = true;
    islemadet?: number = null;
    entLoincKodu?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    entPanel?: string = "H";
    entPanelBool?: boolean = false;
    faturaKodu?: string = "";
    searchText?: string = "";
    grup?: string = "";
    paketKodu?: string = "";
    analizaciklama?: string = "";
    adetsor?: string = "H";
    adetsorBool?: boolean = false;
    faturaPuan?: number = null;
    gensecimDurum?: string = "Y";
    minGenSayisi?: number = null;
    maxGenSayisi?: number = null;
    huvBirim?: number = null;
    islemtanimtipId?: number = null;
    kdvoran?: number = null;
    disEntegrasyonKodu?: string = "";
    kotaGun?: number = null;
    sonucDegerleri?: number = null;
}
export default VwHbsIslemtanimDTO;